import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "simple-business-table" }
const _hoisted_2 = { class: "table-container" }
const _hoisted_3 = { class: "body-container" }

import { i18n } from '@/i18n';
import { businessContentName } from '@/appLogic/business/businessTableHeaders';
import TableHead from '@/components/atom/TableHead.vue';
import { TableType } from '@/coreDomainsModule/table';
import { TableCommonViewModel } from '@/viewModels/tableContent';
import TableCell from '@/components/atom/TableCell.vue';
import { ref } from 'vue';
import RowCheckBox from '@/components/atom/RowCheckBox.vue';
import { IBusinessProgressRateInfo } from '../domains/entities/businessProgressRateInfo';

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'SimpleProgressRateTable',
  props: {
    tableType: {},
    items: {},
    scrollEnable: { type: Boolean, default: false },
    editableLeadTime: { type: Boolean, default: false },
    editableStdInventory: { type: Boolean, default: false },
    onlyViewMode: { type: Boolean, default: false }
  },
  emits: ["onClickLeadTimeButton", "onClickStdInventoryButton"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// emits
const emits = __emit;

//変数
const t = i18n.t;
const commonTableContentVm = new TableCommonViewModel();
const isAllChecked = ref(false);

/**
 * テーブルに存在するチェックボックスを全選択する
 * @param isChecked - チェックボックスの状態
 */
const selectAllLines = (isChecked: boolean) => {
  // 単一のチェックマークしか押せないように
  if (commonTableContentVm.checkOnlySingleCheckboxTables(props.tableType)) {
    return;
  }
  // // 全選択用のフラグを切り返る
  // state.isAllChecked = isChecked;
  // // 全選択のチェックボックスがtrueかどうか？
  // if (state.isAllChecked) {
  //   // virtualChild = false の取引のみを対象とする
  //   const parentDisplayObjects = computedDisplayObjects.value
  //     .filter((obj) => !obj.virtualChild)
  //     .filter((obj) => Object.hasOwn(obj, displayObjectKey)); // 表示要素がitemId, bomIdの場合、プロパティがundefinedの可能性があるため ただし、もっと上位でやるべきでは？
  //   state.checkedIds = parentDisplayObjects.map((x) => x[displayObjectKey]);
  // } else {
  //   // 選択解除
  //   clearCheckIds();
  // }
  // if (onCheckIds) onCheckIds(state.checkedIds, props.tableType);
};

/**
 * 更新率計算
 * @param updated -
 * @param total -
 */
const testMethod = (updated: number, total: number): number => {
  const progressRate = Math.floor((updated / total) * 100);
  if (!isFinite(progressRate)) {
    if (Number.isNaN(progressRate) || progressRate === undefined) return 0;
    return 100;
  }
  return progressRate;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(commonTableContentVm).displayHeaders[_ctx.tableType], (property, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (property === 'choice')
                ? (_openBlock(), _createBlock(TableHead, {
                    key: 0,
                    "text-align": 'left'
                  }, {
                    default: _withCtx(() => [
                      (!props.onlyViewMode)
                        ? (_openBlock(), _createBlock(RowCheckBox, {
                            key: 0,
                            modelValue: isAllChecked.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isAllChecked).value = $event)),
                            "is-checked": isAllChecked.value,
                            onChangeStatus: _cache[1] || (_cache[1] = ($event: any) => (selectAllLines($event)))
                          }, null, 8, ["modelValue", "is-checked"]))
                        : _createCommentVNode("", true)
                    ], undefined, true),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(TableHead, {
                    key: 1,
                    "text-align": 'left'
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(businessContentName)[property]), 1)
                    ], undefined, true),
                    _: 2
                  }, 1024))
            ], 64))
          }), 128))
        ])
      ]),
      _createElementVNode("tbody", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item, itemIndex) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: itemIndex,
            class: "item-container"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(commonTableContentVm).displayHeaders[_ctx.tableType], (property, propertyIndex) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: propertyIndex }, [
                (property === 'choice')
                  ? (_openBlock(), _createBlock(TableCell, { key: 0 }, {
                      default: _withCtx(() => [
                        (!props.onlyViewMode)
                          ? (_openBlock(), _createBlock(RowCheckBox, {
                              key: 0,
                              modelValue: isAllChecked.value,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isAllChecked).value = $event)),
                              "is-checked": isAllChecked.value,
                              onChangeStatus: _cache[3] || (_cache[3] = ($event: any) => (selectAllLines($event)))
                            }, null, 8, ["modelValue", "is-checked"]))
                          : _createCommentVNode("", true)
                      ], undefined, true),
                      _: 1
                    }))
                  : (property === 'progressRate')
                    ? (_openBlock(), _createBlock(TableCell, {
                        key: 1,
                        "text-align": 'left',
                        scope: "col"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(`${testMethod(item.updatedBusinessCount, item.totalBusinessCount)}%`), 1)
                        ], undefined, true),
                        _: 2
                      }, 1024))
                    : (_openBlock(), _createBlock(TableCell, { key: 2 }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item[property]), 1)
                        ], undefined, true),
                        _: 2
                      }, 1024))
              ], 64))
            }), 128))
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})